import React from 'react';
import axios from 'axios';
import {NavLink, Route} from 'react-router-dom';
import {Redirect} from 'react-router';
import LoadingSpinner from '../loadingspinner/LoadingSpinner';
import {Context} from "../configcontext/ConfigContext";
import User from "../user/User";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdminUserCount.css';

class AdminUserCount extends React.Component{

	static contextType = Context;

	constructor(props) {
		super(props);
			this.state = {
		    loading: true,
		    numUsers: 0,
		    modalBody: "",
		    selected: false,
		    moduleBoolText: "",
		    modalHeader: "",
		    show: false
		}
		this.showModal = this.showModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.updateModuleColor = this.updateModuleColor.bind(this);
	}

	updateModuleColor(e){
		var moduleBoolText = e.target.id;
		this.props.updateModules(moduleBoolText);
		if(this.state.selected){
			this.setState({selected: false});
		}else{
			this.setState({selected: true});
		}
	}


  	componentDidMount() {
	  	this.setState({loading: false, moduleBoolText: this.props.moduleBoolText});
	  	let value = this.context;
	    axios.post('https://www.arutility.com/api/v4/users/adminGetCount.php',{},{headers: {Authorization: 'Bearer ' + value.jwt}})
		.then(res => {
		    var numUsers = res.data["numUsers"];
		    this.setState({ numUsers: numUsers, loading: false });
		}).catch(error => {
	        if (error.response) {
	        	this.setState({loading: false});
		    } else if (error.request) {
		      // The request was made but no response was received
		        this.setState({loading: false});
		    } else {
		      // Something happened in setting up the request that triggered an Error
		        this.setState({loading: false});
		    }
	    });
  	}

  	componentDidUpdate(){
  		if(this.props.selected != this.state.selected){
  			this.setState({selected: this.props.selected});
  		}
  	}

  	showModal(){
    	this.setState({show: true});
  	}

  	closeModal(){
    	this.setState({show: false});
  	}

  	render(){
	  	let value = this.context;
	  	const {loading, users, authorized, show} = this.state;
	  	if(value.jwt == ""){
	      return(
	        <Route>
	          <Redirect to="/login" />
	        </Route>
	      );
	    }else{
	    	if(value.userPermissions.includes("user:super")){
			    return (
			   		<div className="adminModuleWrapper" className={this.state.selected ? "adminModuleWrapperSelected" : "adminModuleWrapper" } id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   			<div className="adminModuleLarge" id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   				{this.state.numUsers}
			   			</div>
			   			<div className="adminModuleFooter" id={this.state.moduleBoolText} onClick={this.updateModuleColor}>
			   				# of Users
			   			</div>
			   		</div>
			    );
			}else{
		       return null;
		    }
		}
  	}
}

export default AdminUserCount;